import { Fab } from '@mui/material'
import { useNavigate } from 'react-router-dom'
// import CameraAltIcon from '@mui/icons-material/CameraAlt'

import { joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'

import { useStyles } from './styles'
import PlusIcon from 'src/assets/icons/v2/PlusIcon'

export const FABScan = () => {
  const classes = useStyles()
  const navigate = useNavigate()

  const handleNavigate = () => {
    navigate(joinAbsRoute(ROUTES.SCANS_CAMERA_CREATE))
  }

  return (
    <Fab className={classes.fab} size="large" onClick={handleNavigate} color="primary">
      {/* <CameraAltIcon /> */}
      <PlusIcon size="32" />
    </Fab>
  )
}
